import { render, staticRenderFns } from "./PositiveNegative.vue?vue&type=template&id=24d8bcb4"
import script from "./PositiveNegative.vue?vue&type=script&lang=js"
export * from "./PositiveNegative.vue?vue&type=script&lang=js"
import style0 from "./PositiveNegative.vue?vue&type=style&index=0&id=24d8bcb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports